import cookieHelper from './cookieHelper';

const isJwtTokenStored = () =>
  cookieHelper.get(process.env.REACT_APP_TN) && cookieHelper.get(process.env.REACT_APP_TN) !== '';

const getJwtToken = () => (isJwtTokenStored() ? cookieHelper.get(process.env.REACT_APP_TN) : null);

const setJwtToken = jwtToken => sessionStorage.setItem('token', jwtToken);

const removeJwtToken = () => sessionStorage.removeItem('token');

const getHeaders = () => ({
  Authorization: isJwtTokenStored() ? `Bearer ${getJwtToken()}` : '',
  Accept: 'application/json'
});

const getApiPrefix = () => ( isJwtTokenStored() ? '/user' : '');

export {
  isJwtTokenStored,
  getJwtToken,
  setJwtToken,
  removeJwtToken,
  getHeaders,
  getApiPrefix
};